const zhHans = {
  language: {
    login: "登陆",
    inputUserName: "请输入用户名",
    inputUserPassword: "请输入密码",
    userNameVaild: "请输入正确的用户名",
    passwordVaild: "密码不能小于3位",
    panel: "仪表盘",
    filterSearch: "筛选搜索",
    querySearch: "查询搜索",
    inputSearch: "输入搜索：",
    account: "帐号/姓名",
    numbering: "编号",
    accountNumber: "帐号",
    name: "姓名",
    name1: "名称",
    mail: "邮箱",
    lastLogin: "最后登录",
    isUsed: "是否启用",
    action: "操作",
    asigningRole: "分配角色",
    cancle: "取 消",
    clear: "清空",
    save: "保存",
    determined: "确 定",
    editUser: "编辑用户",
    addUser: "添加用户",
    editRole: "编辑角色",
    edit: "编辑",
    addRole: "添加角色",
    password: "密码",
    note: "备注",
    userList: "用户列表",
    changeStatus: "是否要修改？",
    isDelete: "是否要删除？",
    isConfirm: "是否要确认？",
    modificationSuccess: "修改成功",
    addSuccess: "添加成功",
    assignedSuccess: "分配成功",
    cancelModification: "取消修改",
    roleName: "角色名称",
    description: "描述",
    adminCount: "用户数",
    asigningMenu: "分配菜单",
    asigningRes: "分配资源",
    dataList: "数据列表",
    numberCode: "编号",
    levels: "级别",
    goodName: "商品名称",
    topicName: "专题名称",
    goodStatus: "推荐状态",
    status: "状态",
    selectProduct: "选择商品",
    selectTopic: "选择专题",
    recommendedOrNot: "是否推荐",
    setSorting: "设置排序",
    productSearch: "商品名称搜索",
    topicSearch: "专题名称搜索",
    articleNo: "货号",
    notRecommended: "未推荐",
    recommending: "推荐中",
    setRecommending: "设为推荐",
    cancelRecommending: "取消推荐",
    adName: "广告名称",
    adLocation: "广告位置",
    selectTime: "请选择时间",
    addAD: "添加广告",
    goodsQuality: "商品数量",
    quantityUnit: "数量单位",
    navigationBar: "导航栏",
    isDisplay: "是否显示",
    sorting: "排序",
    setting: "设置",
    adPic: "广告图片",
    adUrl: "广告链接",
    adRemarks: "广告备注",
    time: "时间",
    onOffline: "上线/下线",
    online: "上线",
    offline: "下线",
    order: "生成订单",
    clickCount: "点击次数",
    pcCarousel: "PC首页轮播",
    appCarousel: "APP首页轮播",
    inputAdName: "请输入广告名称",
    inputAdNameLength: "长度在 2 到 140 个字符",
    inputAdUrl: "请输入广告链接",
    inputAdStart: "请选择开始时间",
    inputAdEnd: "请选择到期时间",
    inputAdPic: "请选择广告图片",
    upload: "上传",
    uploadRule: "只能上传jpg/png文件，且不超过10MB",
    uploadRule2: "最多只能上传",
    viewSubordinates: "查看下级",
    transferGoods: "转移商品",
    actions: "操作",
    modificationSucceeded: "修改成功",
    deleteText: "是否要删除该品牌？",
    confirm: "确定",
    cancel: "取消",
    level1: "一级",
    level2: "二级",
    category: "分类",
    categoryName: "分类名称：",
    parentCategory: "上级分类：",
    yes: '是',
    no: "否",
    displayInBar: "是否显示在导航栏",
    categoryIcon: "分类图标",
    add: "新增",
    keyWord: "关键词",
    categoryDescription: "分类描述",
    submit: "提交",
    reset: "重置",
    enterBrand: "请输入品牌名称",
    charLength: "长度在 2 到 140 个字符",
    noParentCategory: "无上级分类",
    whetherSubmit: "是否提交数据",
    submittedSuccessfully: "提交成功",
    validationFailed: "验证失败",
    keepLeastOne: "至少要留一个",
    addUpThree: "最多添加三个",
    filteringAttributes: "筛选属性",
    product: "商品",
    productList: "商品列表",
    productCategory: "商品分类",
    addCategory: "添加商品分类",
    modifyCategory: "修改商品分类",
    typeName: "类型名称",
    numberAttributes: "属性数量",
    numberParameters: "参数数量",
    attributeList: "属性列表",
    listParameters: "参数列表",
    enterType: "请输入类型名称",
    additionType: "添加类型",
    resourceName: "资源名称",
    resourcePath: "资源路径",
    resourceClassification: "资源分类",
    editResource: "编辑资源",
    addResource: "添加资源",
    editType: "编辑类型",
    attributeName: "属性名称",
    productType: "商品类型",
    isOptional: "属性是否可选",
    attributeRecordingMethod: "属性值的录入方式",
    optionalList: "可选值列表",
    batchOperations: "批量操作",
    selectRecord: "请选择一条记录",
    selectOperationTypes: "请选择批量操作类型",
    isDeleteAttribute: "是否要删除该属性",
    pickList: "从列表中选取",
    manualInput: "手工录入",
    choose1: "单选",
    choose2: "多选",
    choose3: "唯一",
    pleaseSelect: "请选择",
    categoryFilterStyle: "分类筛选样式",
    ordinary: "普通",
    color: "颜色",
    canSearched: "能否进行检索",
    search1: "不需要检索",
    search2: "关键字检索",
    search3: "范围检索",
    offeringAssociation: "商品属性关联",
    availableAttributeList: "属性值可选值列表",
    supportAddition: "是否支持手动新增",
    sortingAttributes: "排序属性",
    enterAttributeName: "请输入属性名称",
    offeringAttributeList: "商品属性列表",
    addingProductAttribute: "添加商品属性",
    modifyingOfferingSttributes: "修改商品属性",
    pageLose: "很抱歉，页面它不小心迷路了！",
    checkPageText: "请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告",
    returnHome: "返回首页",
    searchResult: "查询结果",
    productName: "商品名称",
    productNo: "商品货号",
    productBrand: "商品品牌",
    selectBrand: "选择品牌",
    onStatus: "上架状态",
    all: "全部",
    reviewStatus: "审核状态",
    increase: "添加",
    productImage: "商品图片",
    brand: "品牌",
    price: "价格",
    goodsNo: "货号",
    labels: "标签",
    OnShelf: "上架",
    newProducts: "新品",
    recommends: "推荐",
    SKUInventory: "SKU库存",
    salesVolume: "销量",
    reviewDetails: "审核详情",
    view: "查看",
    edits: "编辑",
    logs: "日志",
    delete: "删除",
    editInformation: "编辑货品信息",
    searchSkuNumber: "按sku编号搜索",
    SKUNumber: "SKU编号",
    salesPrice: "销售价格",
    merchandiseInventory: "商品库存",
    inventoryAlarmValue: "库存预警值",
    productListing: "商品上架",
    productRemoval: "商品下架",
    setAsRecommended: "设为推荐",
    cancelRecommendation: "取消推荐",
    setAsNew: "设为新品",
    cancelNewProduct: "取消新品",
    transferCategory: "转移到分类",
    moveRecycleBin: "移入回收站",
    offShelf: "下架",
    approved: "审核通过",
    notApproved: "未审核",
    noSKUInformation: "暂无sku信息",
    isModify: "是否要进行修改",
    tips: "提示",
    selectOperationType: "请选择操作类型",
    selectProductOperated: "请选择要操作的商品",
    sureOperations: "是否要进行该批量操作？",
    sureDelete: "是否要进行删除操作",
    deletedSuccessfully: "删除成功",
    attributeType: "属性类型",
    selectAttributeType: "请选择属性类型",
    productSpecification: "商品规格",
    promotionPrice: "促销价格",
    refreshList: "刷新列表",
    synchronizePrices: "同步价格",
    synchronizeInventory: "同步库存",
    propertyPicture: "属性图片",
    offeringParameters: "商品参数",
    productAlbum: "商品相册",
    productDetails: "商品详情",
    computerDetails: "电脑端详情",
    mobileDetails: "移动端详情",
    backPromotion: "上一步，填写商品促销",
    nextAssociation: "下一步，选择商品关联",
    attributeCannotEmpty: "属性值不能为空",
    attributeCannotDuplicate: "属性值不能重复",
    sureSKURefresh: "刷新列表将导致sku信息重新生成，是否要刷新",
    sureSKUSynchronized: "将同步第一个sku的价格到所有sku,是否继续",
    sureSKUInventory: "将同步第一个sku的库存到所有sku,是否继续",
    fillProductInformation: "填写商品信息",
    fillProductPromotion: "填写商品促销",
    enteringOfferingAttributes: "填写商品属性",
    selectProductAssociation: "选择商品关联",
    sureSubmit: "是否要提交该产品",
    subtitle: "副标题",
    productIntroduction: "商品介绍",
    enterContent: "请输入内容",
    productPrice: "商品售价",
    marketPrice: "市场价",
    unitsMeasurement: "计量单位",
    productWeight: "商品重量",
    gram: "克",
    nextPromotion: "下一步，填写商品促销",
    enterProductName: "请输入商品名称",
    enterProductSubtitle: "请输入商品副标题",
    selectProductSategory: "请选择商品分类",
    selectProductBrand: "请选择商品品牌",
    enterProductDescription: "请输入商品介绍",
    itemMandatory: "该项为必填项",
    associatedTopics: "关联专题",
    enterTopicName: "请输入专题名称",
    associationSelection: "关联优选",
    enterPreferredName: "请输入优选名称",
    backFillAttributes: "上一步，填写商品属性",
    finishSubmitProduct: "完成，提交商品",
    toBeSelected: "待选择",
    isSelected: "已选择",
    rewardingBonusPoints: "赠送积分",
    rewardGrowthValue: "赠送成长值",
    pointPurchaseRestriction: "积分购买限制",
    preAnnouncedGoods: "预告商品",
    offeringRecommendation: "商品推荐",
    serviceAssurance: "服务保证",
    hassleFreeReturns: "无忧退货",
    quickRefund: "快速退款",
    freePostage: "免费包邮",
    detailPageTitle: "详细页标题",
    detailPageDescription: "详细页描述",
    commodityKeyword: "商品关键字",
    productRemarks: "商品备注",
    selectPreferenceMode: "选择优惠方式",
    noDiscount: "无优惠",
    specialPromotions: "特惠促销",
    memberPrice: "会员价格",
    tieredPrice: "阶梯价格",
    fullyReducedPrice: "满减价格",
    startTime: "开始时间",
    selectStartTime: "选择开始时间",
    endTime: "结束时间",
    selectEndTime: "选择结束时间",
    enterPromotionalPrice: "输入促销价格",
    quantity: "数量",
    discounts: "折扣",
    fulls: "满",
    immediateReduction: "立减",
    backFillInformation: "上一步，填写商品信息",
    nextProductAttributes: "下一步，填写商品属性",
    maximumThree: "最多只能添加三条",
    addingProduct: "添加商品",
    modifyingProduct: "修改商品",
    enterSearch: "输入搜索",
    brandName: "品牌名称",
    searchBrandName: "品牌名称搜索",
    keywords: "关键字",
    brandInitials: "品牌首字母",
    brandManufacturer: "品牌制造商",
    related: "相关",
    evaluations: "评价",
    displayBrand: "显示品牌",
    hideBrand: "隐藏品牌",
    sureDeleteBrand: "是否要删除该品牌",
    brandLOGO: "品牌LOGO",
    brandBigPicture: "品牌专区大图",
    brandStory: "品牌故事",
    enterBrandLogo: "请输入品牌logo",
    orderMustNumeric: "排序必须为数字",
    brandManagement: "品牌管理",
    addBrand: "添加品牌",
    editBrand: "编辑品牌",
    shipmentList: "发货列表",
    orderNumber: "订单编号",
    consignee: "收货人",
    mobilePhoneNumber: "手机号码",
    postalCode: "邮政编码",
    shipToAddress: "收货地址",
    shippingMethod: "配送方式",
    selectLogisticsCompany: "请选择物流公司",
    logisticsOrderNo: "物流单号",
    SFExpress: "顺丰快递",
    YuantongExpress: "圆通快递",
    ZhongtongExpress: "中通快递",
    YundaExpress: "韵达快递",
    doPerformShipment: "是否要进行发货操作？",
    shipmentSucceeded: "发货成功",
    shipmentCancelled: "已取消发货",
    submittedTime: "提交时间",
    nameConsignee: "收货人姓名",
    orderStatus: "订单状态",
    orderClassification: "订单分类",
    orderSource: "订单来源",
    userAccount: "用户账号",
    orderAmount: "订单金额",
    modePayment: "支付方式",
    viewOrders: "查看订单",
    closeOrder: "关闭订单",
    orderShipment: "订单发货",
    orderTracking: "订单跟踪",
    deleteOrders: "删除订单",
    operationRemarks: "操作备注",
    pendingPayment: "待付款",
    pendingShipment: "待发货",
    shipped: "已发货",
    completed: "已完成",
    closed: "已关闭",
    normalOrder: "正常订单",
    seckillOrder: "秒杀订单",
    PCOrders: "PC订单",
    APPOrder: "APP订单",
    bulkShipment: "批量发货",
    Paypal: "支付宝",
    Wechat: "微信",
    unpaid: "未支付",
    invalidOrder: "无效订单",
    selectOrderOperate: "请选择要操作的订单",
    noShipOrder: "选中订单中没有可以发货的订单",
    remarkNotEmpty: "操作备注不能为空",
    deleteSure: "是否要进行该删除操作？",
    submittingOrder: "提交订单",
    paymentOrder: "支付订单",
    platformDelivery: "平台发货",
    confirmReceipt: "确认收货",
    completeEvaluation: "完成评价",
    currentOrderStatus: "当前订单状态",
    modifyConsigneeInformation: "修改收货人信息",
    modifyingFeeInformation: "修改费用信息",
    sendingInternalMessage: "发送站内信",
    remarksOrder: "备注订单",
    cancelingOrder: "取消订单",
    basicInfo: "基本信息",
    serialNumber: "发货单流水号",
    orderType: "订单类型",
    nonePresent: "暂无",
    automaticConfirmationReceiving: "自动确认收货时间",
    preferentialCurrencyOrders: "订单可得优币",
    growthValueOrders: "订单可得成长值",
    eventInfo: "活动信息",
    consigneeInformation: "收货人信息",
    productInformation: "商品信息",
    attributes: "属性",
    subtotal: "小计",
    totals: "合计",
    feeInformation: "费用信息",
    totalCommodities: "商品合计",
    freightCharges: "运费",
    coupons: "优惠券",
    bonusPointDeduction: "积分抵扣",
    eventOffers: "活动优惠",
    discountAmount: "折扣金额",
    totalOrderAmount: "订单总金额",
    amountPayable: "应付款金额",
    operatioInfo: "操作信息",
    operators: "操作者",
    operationTime: "操作时间",
    paymentStatus: "付款状态",
    shipmentStatus: "发货状态",
    regions: "所在区域",
    detailedAddress: "详细地址",
    titles: "标题",
    contents: "内容",
    refunded: "已退款",
    paid: "已支付",
    unshipped: "未发货",
    modifyReceivingInformation: "是否要修改收货信息？",
    modifyFeeInformation: "是否要修改费用信息？",
    sentSuccessfully: "发送成功",
    sendInternalMessage: "是否要发送站内信？",
    doClose: "是否要关闭？",
    orderClosedSuccessfully: "订单关闭成功",
    whetherRemarkOrder: "是否要备注订单？",
    orderRemarkSucceeded: "订单备注成功",
    sureCancelOrder: "是否要进行取消订单操作？",
    canceledSuccessfully: "取消成功",
    sureDeletion: "是否要进行该删除操作？",
    seckillOrdersExceed: "秒杀订单超过",
    minute: "分",
    orderAutomaticallyClosed: "未付款，订单自动关闭",
    normalOrdersOver: "正常订单超过",
    shipmentExceeds: "发货超过",
    day: "天",
    orderAutomaticallyCompleted: "未收货，订单自动完成",
    ordersCompletedOver: "订单完成超过",
    transactionAutomaticallyEnded: "自动结束交易，不能申请售后",
    fivestarReviews: "自动五星好评",
    timeCannotEmpty: "时间不能为空",
    enterNumericValue: "请输入数字值",
    sureSubmitModification: "是否要提交修改？",
    parameterInvalid: "提交参数不合法",
    submittedWaitingPayment: "订单已提交，等待付款",
    paidSuccessfully: "订单付款成功",
    scanPendingPayment: "在北京市进行下级地点扫描，等待付款",
    ShenzhenWaitingPayment: "在分拨中心广东深圳公司进行卸车扫描，等待付款",
    scanningShenzhenCompany: "在广东深圳公司进行发出扫描",
    deliveredSoon: "到达目的地网点广东深圳公司，快件将很快进行派送",
    receivedText: "订单已签收，期待再次为您服务",
    orders: "订单",
    orderList: "订单列表",
    orderDetails: "订单详情",
    orderSettings: "订单设置",
    menuName: "菜单名称",
    frontendPic: "前端图标",
    frontendName: "前端名称",
    menuLevel: "菜单级数",
    upperMenu: "上级菜单",
    selectMenu: "请选择菜单",
    inputMenuName: "请输入菜单名称",
    inputFrontendName: "请输入前端名称",
    inputFrontendPic: "请输入前端图标",
    noUpperMenu: "无上级菜单",
    activityName: "活动名称",
    settingProduct: "设置商品",
    activityTitle: "活动标题",
    activityStatus: "活动状态",
    seckillingTime: "秒杀时间段列表",
    addActivity: "添加活动",
    activityProgress: "活动进行中",
    activityEnded: "活动已结束",
    activityNotStarted: "活动未开始",
    seckillingTimeName: "秒杀时间段名称",
    enabled: "启用",
    AddTimeSegment: "添加时间段",
    returnedGoods: "退货商品",
    serviceOrderInformation: "服务单信息",
    serviceOrderNo: "服务单号",
    applicationStatus: "申请状态",
    timeApplication: "申请时间",
    contactPerson: "联系人",
    contactPhone: "联系电话",
    reasonReturn: "退货原因",
    problemDescription: "问题描述",
    voucherPicture: "凭证图片",
    confirmRefundAmount: "确认退款金额",
    selectReceivingPoint: "选择收货点",
    processingPersonnel: "处理人员",
    processingTime: "处理时间",
    processingRemarks: "处理备注",
    receivingPersonnel: "收货人员",
    receivingTime: "收货时间",
    receiptRemarks: "收货备注",
    confirmReturn: "确认退货",
    rejectReturn: "拒绝退货",
    unprocessed: "待处理",
    returning: "退货中",
    rejected: "已拒绝",
    sureOperation: "是否要进行此操作？",
    operationSucceeded: "操作成功",
    processingStatus: "处理状态",
    operatorPerson: "操作人员",
    refundAmount: "退款金额",
    viewDetails: "查看详情",
    bulkDelete: "批量删除",
    selectApplication: "请选择要操作的申请",
    reasonType: "原因类型",
    available: "是否可用",
    usable: "可用",
    addTime: "添加时间",
    addReturnReason: "添加退货原因",
    statusModifiedSuccessfully: "状态修改成功",
    selectOperation: "请选择要操作的条目",
    sureDeleteText: "是否要进行该删除操作",
    returnRequestProcessing: "退货申请处理",
    returnReasonSettings: "退货原因设置",
    returnReasonDetails: "退货原因详情",
    remainingQuantity: "剩余数量",
    seckillPrice: "秒杀价格",
    restrictedQuantity: "限购数量",
    seckillNum: "秒杀数量",
    editSeckillProduct: "编辑秒杀商品信息",
    addNotice: "添加通知",
    noticeTitle: "通知标题",
    noticeIntroduce: "通知介绍",
    noticeContent: "通知内容",
    noticePic: "通知图片",
    home: "首页",
    exit: "退出",
    couponName: "优惠券名称",
    couponType: "优惠券类型",
    availableProduct: "可使用商品",
    usageThreshold: "使用门槛",
    alreadyUsed: "已使用",
    notUsed: "未使用",
    faceValue: "面值",
    applicablePlatform: "适用平台",
    validityPeriod: "有效期",
    allCoupon: "全场赠券",
    membershipCoupon: "会员赠券",
    giftCoupon: "购物赠券",
    registrationCoupon: "注册赠券",
    notExpired: "未过期",
    expired: "已过期",
    mobilePlatform: "移动平台",
    pcPlatform: "PC平台",
    allPlatform: "全平台",
    wholeSite: "全场通用",
    proactiveAcquisition: "主动获取",
    backgroundReward: "后台赠送",
    specifiedCategory: "指定分类",
    specifiedProduct: "指定商品",
    totalOrdersToday: "今日订单总数",
    totalSalesToday: "今日销售总额",
    totalSalesYesterday: "昨日销售总额",
    pendingTransactions: "待处理事务",
    pendingOrders: "待付款订单",
    completedOrders: "已完成订单",
    ordersToConfirmed: "待确认收货订单",
    ordersShip: "待发货订单",
    newShortageRegistration: "新缺货登记",
    pendingRefundRequests: "待处理退款申请",
    shippedOrders: "已发货订单",
    pendingReturnOrders: "待处理退货订单",
    adPositionExpire: "广告位即将到期",
    productOverview: "商品总览",
    offShelf2: "已下架",
    onShelf: "已上架",
    tightInventory: "库存紧张",
    allProducts: "全部商品",
    userOverview: "用户总览",
    addedToday: "今日新增",
    addedYesterday: "昨日新增",
    newTheMonth: "本月新增",
    totalNumberMembers: "会员总数",
    orderStatistics: "订单统计",
    totalOrdersMonth: "本月订单总数",
    comparedLastMonth: "同比上月",
    totalOrdersThisWeek: "本周订单总数",
    comparedLastWeek: "同比上周",
    totalAmountMonth: "本月销售总额",
    totalSalesWeek: "本周销售总额",
    toThe: "至",
    startDate: "开始日期",
    endDate: "结束日期",
    withinLastWeek: "最近一周",
    withinLastMonth: "最近一月",
    numberOrders: "订单数量",
    videoTutorials: "视频教程",
    totalCirculation: "总发行量",
    couponRule1: "只能输入正整数",
    couponRule2: "面值只能是数值，限2位小数",
    couponRule3: "面值只能是数值，0.01-10000，限2位小数",
    cny: "元",
    limitPerson: "每人限领",
    piece: "张",
    pickupDate: "领取日期",
    received: "已领取",
    promoCode: "优惠码",
    receiveMembership: "领取会员",
    claimingMethod: "领取方式",

    toBeReceived: "已领取",
    selectDate: "选择日期",
    to: "至",
    selectCategoryName: "请选择分类名称",
    categoryName2: "分类名称",
    enterCoupon: "请输入优惠券名称"
  },
  menus: {
    首页: "首页",
    仪表盘: "仪表盘",
    商品: "商品",
    商品列表: "商品列表",
    添加商品: "添加商品",
    商品分类: "商品分类",
    商品类型: "商品类型",
    品牌管理: "品牌管理",
    订单: "订单",
    订单列表: "订单列表",
    订单设置: "订单设置",
    退货申请处理: "退货申请处理",
    退货原因设置: "退货原因设置",
    营销: "营销",
    秒杀活动列表: "秒杀活动列表",
    优惠券列表: "优惠券列表",
    品牌推荐: "品牌推荐",
    新品推荐: "新品推荐",
    人气推荐: "人气推荐",
    专题推荐: "专题推荐",
    广告列表: "广告列表",
    通知列表: "通知列表",
    权限: "权限",
    用户列表: "用户列表",
    角色列表: "角色列表",
    菜单列表: "菜单列表",
    资源列表: "资源列表"
  }
}
export default zhHans;



// WEBPACK FOOTER //
// ./src/locale/zh-Hans.js